"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getButtonTemplate = exports.ButtonTemplateStyle = void 0;
const lit_html_1 = require("lit-html");
/**
 * Стиль кнопки
 */
var ButtonTemplateStyle;
(function (ButtonTemplateStyle) {
    ButtonTemplateStyle["BLACK"] = "black";
    ButtonTemplateStyle["RED"] = "red";
    ButtonTemplateStyle["TRANSPARENT"] = "transparent";
})(ButtonTemplateStyle = exports.ButtonTemplateStyle || (exports.ButtonTemplateStyle = {}));
/**
 * Возвращает стиль кнопки
 */
function getButtonClassByStyle(style) {
    switch (style) {
        case ButtonTemplateStyle.BLACK:
            return 'btn--black';
        case ButtonTemplateStyle.RED:
            return 'button--red';
        default:
            return 'button--transparent';
    }
}
/**
 * Возвращает шаблон кнопки
 */
function getButtonTemplate(domain, style = ButtonTemplateStyle.TRANSPARENT, translations) {
    const classes = ['button', getButtonClassByStyle(style)];
    if (domain.banned) {
        return (0, lit_html_1.html) `
            <button class="${classes.join(' ')}" type="button">${translations.instant('notForSale')}</button>
        `;
    }
    if (domain.request) {
        // classes.push('js-request-domain');
        classes.push('art-ajaxer-popup-2');
        return (0, lit_html_1.html) `
            <button class="${classes.join(' ')}" data-popup="reserved" data-name="${[domain.name, domain.zone].join('.')}" type="button">${translations.instant('requestDomain')}</button>
        `;
    }
    if (domain.bought) {
        return (0, lit_html_1.html) `
            <span class="button btn--disabled">${translations.instant('soldOut')}</span>
        `;
    }
    if (domain.auction) {
        // classes.push('js-domain-reserved');
        classes.push('art-ajaxer-popup-2');
        return (0, lit_html_1.html) `
            <button class="${classes.join(' ')}" data-popup="reserved" data-name="${[domain.name, domain.zone].join('.')}" data-reserved="${domain.reserved}" type="button">${translations.instant('requestDomain')}</button>
        `;
    }
    if (domain.inCart) {
        classes.push('');
        return (0, lit_html_1.html) `
            <a class="${classes.join(' ')}" href="/cart">${translations.instant('goToCart')}</a>
        `;
    }
    classes.push('js-domain-buy-now');
    let fastTrack = 0;
    if ([domain.name, domain.zone].join('.').split('.').length > 2) {
        fastTrack = 1;
    }
    // Todo: Fasttrack, on search page = 0
    return (0, lit_html_1.html) `
        <button class="${classes.join(' ')}" data-id="domain_${[domain.name, domain.zone].join('.')}" data-name="${[domain.name, domain.zone].join('.')}" data-fast-track="${fastTrack}">${translations.instant('buyNow')}</button>
    `;
}
exports.getButtonTemplate = getButtonTemplate;
